import React from "react";
import { Link } from 'react-router-dom';
import WalletDashboard from "../components/WalletDashboard";

function Wallet() {
    return (
        <main className="main-sectionWrapper">
            <div id="main-section" className="primary-scroll">

                {/* Header */}
                <div style={styles.headerBar}>
                    <Link to="/welcome" style={styles.backBtn} aria-label="Back to Home">
                        <i className='bx bx-chevron-left' style={styles.backIcon}></i>
                    </Link>
                    <span style={styles.headerTitle}>My Wallet</span>
                    <div style={styles.headerRight}>
                        <div style={styles.headerIconBtn} aria-label="Wallet settings">
                            <i className='bx bx-dots-horizontal-rounded' style={{ color: 'rgba(255,255,255,0.6)', fontSize: 20 }}></i>
                        </div>
                    </div>
                </div>

                <WalletDashboard />
            </div>
        </main>
    );
}

const styles = {
    headerBar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '10px 14px',
        background: 'rgba(14,7,88,0.88)',
        backdropFilter: 'blur(16px)',
        WebkitBackdropFilter: 'blur(16px)',
        position: 'sticky',
        top: 0,
        zIndex: 100,
        borderBottom: '1px solid rgba(255,255,255,0.06)',
    },
    backBtn: {
        width: 38,
        height: 38,
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.08)',
        border: '1px solid rgba(255,255,255,0.06)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        textDecoration: 'none',
        flexShrink: 0,
    },
    backIcon: {
        color: '#fff',
        fontSize: 22,
    },
    headerTitle: {
        color: '#fff',
        fontSize: 16,
        fontWeight: 700,
        letterSpacing: '-0.2px',
        flex: 1,
        textAlign: 'center',
    },
    headerRight: {
        width: 38,
        display: 'flex',
        justifyContent: 'flex-end',
    },
    headerIconBtn: {
        width: 38,
        height: 38,
        borderRadius: '50%',
        background: 'rgba(255,255,255,0.06)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
    },
};

export default Wallet;
